
import React from 'react';
import { motion } from 'framer-motion';
import { techStack } from '../data/mock';
import { Card, CardHeader, CardTitle, CardContent } from './ui/card';

const TechStack = () => {
  return (
    <section className="py-12 lg:py-16 bg-white overflow-hidden">
      <div className="container mx-auto px-4 mb-8">
        <div className="text-center max-w-3xl mx-auto">
          <motion.span 
            className="inline-block px-4 py-1 rounded-full bg-indigo-50 text-indigo-900 font-medium text-sm mb-4"
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            Technology & Expertise
          </motion.span>
          <motion.h2 
            className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6"
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            Technologies We Master
          </motion.h2>
          <motion.p 
             className="text-lg text-gray-600"
             initial={{ opacity: 0, y: 10 }}
             whileInView={{ opacity: 1, y: 0 }}
             viewport={{ once: true }}
             transition={{ delay: 0.2 }}
          >
            We use the latest frameworks and tools to build robust, scalable, and high-performance solutions.
          </motion.p>
        </div>
      </div>

      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {techStack.map((category, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.1 }}
            >
              <Card className="h-full border-2 border-gray-100 hover:border-indigo-100 hover:shadow-xl transition-all duration-300">
                <CardHeader className="p-4 pb-2">
                  <CardTitle className="text-xl font-bold text-gray-900">{category.category}</CardTitle>
                </CardHeader>
                <CardContent className="p-4 pt-0">
                  <div className="grid grid-cols-4 gap-3">
                    {category.items.map((item, itemIdx) => (
                      <div 
                        key={itemIdx}
                        className="flex flex-col items-center justify-center p-2 aspect-square bg-gray-50 rounded-xl hover:bg-white hover:shadow-md transition-all duration-300 group"
                      >
                        <div className="w-8 h-8 mb-2 relative flex items-center justify-center">
                          <img 
                            src={item.icon} 
                            alt={item.name} 
                            className="w-full h-full object-contain transition-all duration-300 transform group-hover:scale-110"
                          />
                        </div>
                        <span className="text-[10px] font-medium text-gray-500 group-hover:text-indigo-900 text-center leading-tight">
                          {item.name}
                        </span>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechStack;
